export const useParseQueryParams = (searchParams, name) => {
    try {
        const raw = searchParams.get(name);

        if (!raw) {
            return [];
        };

        const decoded = decodeURIComponent(raw);
        const parsed = JSON.parse(decoded);

        console.log("PARSED: ", parsed);


        const firstCondition = Array.isArray(parsed);
        const secondCondition = parsed.every((crumb) => crumb.title);

        // Validate structure
        if (firstCondition && secondCondition) {
            return parsed;
        }

        else {
            return [];
        };
    }

    catch (error) {
        console.error("ERROR: ", error);
        return [];
    };
};